<template>
	<v-col class="purchase-product">
		<ModalDetail ref="modalDetail" :articleType="'Berita'"></ModalDetail>
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Berita</div>
		</div>
		<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
			<v-icon small color="grey">mdi-newspaper-variant-multiple-outline</v-icon>
			<div class="pl-2">Berita &amp; Pengumuman</div>
			<div class="px-2">/</div>
			<div>Berita</div>
		</div>

		<template v-if="!loading">
			<div class="mt-5" v-if="listArticle.length > 0">
				<v-row class="ml-0 body-transaction-article">
					<v-col cols="12" sm="4" md="3" xl="3" class="d-flex flex-stretch" v-for="article in listArticle" :key="article.content_id">
						<v-card
							elevation="0"
							rounded-lg
							class="mx-auto mt-2 hover-shadow fill-height"
						>
							<template slot="progress">
								<v-progress-linear
									color="deep-purple"
									height="10"
									indeterminate
								></v-progress-linear>
							</template>

							<v-img
								height="200"
								:src="(article.content_image) ? article.content_image : '/assets/image/no-image-post.png'"
							></v-img>

							<v-card-text class="pb-0">
								<h3 class="font-size-14 black--text line-height-normal font-weight-bold mb-20" v-html="$options.filters.longText(article.content_title, 45)"></h3>
							</v-card-text>
							<v-card-text class="pb-0 pt-1"><span class="cl-secondary">{{ article.content_input_datetime | tanggal }}</span></v-card-text>

							<v-card-text class="pb-1">
								<div v-html="$options.filters.ellipsisText(article.content_body, 120)"></div>
							</v-card-text>

							<!-- <v-divider class="mx-4"></v-divider> -->

							<v-card-actions>
								<v-btn
									color="primary"
									text
									block
									class="px-0"
									@click="showDetailArticle(article.content_slug)"
								>
									Lihat Selengkapnya <v-icon dense class="ml-1">mdi-arrow-right</v-icon>
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-col>
				</v-row>
			</div>

			<div v-else>
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<v-card class="pt-3 elevation-0 rounded-lg">
							<NoData></NoData>
							<div class="pt-3 text-center cl-secondary">Tidak ada data berita yang dapat ditampilkan</div>
						</v-card>
					</v-col>
				</v-row>
			</div>
			
			<div class="mt-3" v-if="listArticle.length > 0">
				<v-row justify="end">
					<v-col cols="12" sm="5" md="6" class="pl-1 pr-0 pb-1 pr-sm-3 pb-sm-3 d-flex justify-sm-start justify-end">
						<v-pagination v-model="page" total-visible="5" class="d-flex justify-end vo-pagination no-button-focus" color="primary" :length="articlePagination.total_page" @input="changePage"></v-pagination>
					</v-col>
					<v-col cols="12" sm="5" md="5" class="pb-0 pb-sm-3 my-auto text-right">
						<div class=" font-size-10">Menampilkan {{ articlePagination.total_display }} data dari total {{ articlePagination.total_data }} data</div>
					</v-col>
					<v-col cols="4" sm="2" md="1">
						<v-autocomplete :items="listLimit" v-model="limit" hide-details dense class="" placeholder="Data" color="primary" @input="changeLimit"></v-autocomplete>
					</v-col>
				</v-row>
			</div>
		</template>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalDetail from './components/ModalDetail';

export default {
	components: { ModalDetail },
	data() {
		return {
			loading: false,
			page: 1,
			limit: '10',
			listLimit: [ '10', '20', '50', '100' ],
			params: [
				{
					type: 'string',
					field: 'content_category_slug',
					value: 'berita'
				}
			],
		}
	},
	computed: {
		...mapState('auth', ['userData']),
		...mapState('article', ['listArticle', 'articlePagination']),
	},
	methods: {
		...mapActions('article', ['getListArticleByCategory', 'getDetailArticle']),

		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		reset() {
			this.page = 1
			this.limit = '10'
			this.params = []
			this.getData()
		},

		async getData() {
			this.loading = await true
			this.getListArticleByCategory(this.queryString({params: this.params, limit:this.limit, page: this.page})).then(() => {
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
				this.loading = false
			})
		},

		showDetailArticle(slug) {
			this.getDetailArticle({content_slug: slug}).then(() => {
				this.$refs.modalDetail.modalShow()
			})
		},
	},
	created(){
		this.$store.dispatch('setPageTitle', `Berita`)
		this.getData()
	},
};
</script>

<style lang="scss">
	.article_desc {
		height: 0.4rem;
		width: inherit;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}	
</style>
